module.exports = __webpack_public_path__ + "img/home.faf8f75a.png";